export default "__VITE_ASSET__Df2W7Qhc__"